import React from "react";

type DescriptionListItemProps = {
  label: string;
  description?: string;
  children?: React.ReactNode;
};
const DescriptionListItem = ({ label, description, children }: DescriptionListItemProps) => {
  return (
    <div className="flex items-center py-5 space-x-4">
      <dt className="text-sm flex-1 min-w-0">
        <p className="font-medium text-gray-900 truncate">{label}</p>
        <p className="text-gray-500 truncate">{description}</p>
      </dt>
      <dd>{children && <span className="ml-4 flex-shrink-0">{children}</span>}</dd>
    </div>
  );
};

export default DescriptionListItem;
